<!-- OrderDetailBody.vue -->
<template>
    <div>
        <div class="common-header-wrap">
            <mt-header title="Order details" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="order-body" v-if="order_info">
            <div class="order_state">
                <i class="iconfont" v-if="order_info.order_state == '40'">&#xe61b;</i>
                <i class="iconfont" v-else>&#xe61a;</i>
                <span>{{order_info.state_desc}}</span>
                <div class="pickup-code" v-if="order_info.order_state == '35'">（Pickup code{{order_info.chain_order_pickup_code}}）</div>
            </div>
            <div class="address">
                <div>
                    <span>{{ order_info.reciver_name }}</span>
                    <span class="mobile">{{ order_info.reciver_phone }}</span>
                </div>
                <p style="-webkit-box-orient: vertical; -webkit-line-clamp: 2;">
                    {{ order_info.reciver_addr }}
                </p>
            </div>
            <div class="order_store" v-if="order_info.extend_store" @click="$router.push({name:'HomeStoredetail', 'query': { 'id': order_info.extend_store.store_id }})">
                <i class="store iconfont">&#xe62d;</i><span>{{order_info.extend_store.store_name}}</span><i class="more iconfont">&#xe650;</i>
            </div>
            <div class="containers" v-for="item in order_info.goods_list" v-bind:key="item.goods_id" @click="$router.push({name:'HomeGoodsdetail',query:{goods_id:item.goods_id}})">
                <img class="photo" v-bind:src="item.image_url" />
                <div class="right-wrapper">
                    <label class="title">{{ item.goods_name }}</label>
<!--                    <label class="property">{{ item.goods_spec }}</label>-->
                    <div class="desc-wrapper">
                        <div>
                            <label class="price">$ {{ item.goods_price }}</label>
                            <label class="count">x{{ item.goods_num }}</label>
                        </div>
                        <div class="btn-list">
                            <mt-button v-if="order_info.if_complain" plain size="small" @click.stop="complaint(order_info.order_id,item.rec_id)">Complaint</mt-button>
                            <mt-button v-if="item.refund=='1'" plain size="small" @click.stop="showRefund(item.rec_id)">After sale</mt-button>
                            <mt-button v-if="item.extend_refund && !(item.extend_refund.refund_state==3 || item.extend_refund.refund_state==4)" plain size="small" @click.stop="goRefund(item.extend_refund)">After sale</mt-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="order_info.zengpin_list" class="containers" v-for="item in order_info.zengpin_list" v-bind:key="item.goods_id">
                <img class="photo" v-bind:src="item.image_url" />
                <div class="right-wrapper">
                    <label class="title"><span class="tag-icon">Giveaway</span>{{ item.goods_name }}</label>
                    <label class="property">{{ item.goods_spec }}</label>
                    <div class="desc-wrapper">
                        <div>
                            <label class="price">$ {{ item.goods_price }}</label>
                            <label class="count">x{{ item.goods_num }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail">
                <div class="number">
                    <label>Order number:{{ order_info.order_sn }}</label>
                    <p>Order time:{{order_info.add_time}}</p>
                </div>
                <div class="pay" v-if="order_info.payment_name">
                    <p>Payment method:{{ order_info.payment_name }}</p>
                </div>
                <div class="number" v-if="hasVoucher">
                  <p>Use vouchers:${{order_info.extend_order_common.voucher_price}}</p>
                </div>
            </div>
            <div class="desc section-header section-footer">
                <div class="container">
                  <label class="title">Estimated volume</label>
                  <label class="subtitle">{{ order_info.goods_volume_total }} m³</label>
                </div>
                <div class="container">
                  <label class="title">Weight</label>
                  <label class="subtitle">{{ order_info.goods_weight_total }} kg</label>
                </div>
                <div class="container">
                    <label class="title">Total merchandise</label>
                    <label class="subtitle">${{ order_info.goods_amount }}</label>
                </div>
<!--                <div class="container" v-if="order_info.payment_code == 'offline'">
                  <label class="title">Initial Payment</label>
                  <label class="subtitle">${{ order_info.initial_amount }}</label>
                </div>
                <div class="container" v-if="order_info.payment_code == 'offline'">
                  <label class="title">Balance Payment</label>
                  <label class="subtitle">${{ order_info.balance_amount }}</label>
                </div>-->
                <div class="container">
                    <label class="title">Freight</label>
                    <label class="subtitle">${{ order_info.shipping_fee }}</label>
                </div>
                <div class="container" v-if="order_info.promotion && order_info.promotion.length > 0">
                    <label class="title">Discount</label>
                    <label class="subtitle" v-for="(p,i) in order_info.promotion" v-bind:key="i">{{p[1]}}}</label>
                </div>

<!--                <div class="container" v-if="order_info.extend_order_common.voucher_code">-->
<!--                  <label class="title">Voucher</label>-->
<!--                  <label class="subtitle">- ${{ order_info.extend_order_common.voucher_price }}</label>-->
<!--                </div>-->

                <label class="amount">Actual payment:<span> ${{ order_info.order_amount }}</span></label>
                <router-link
                  v-if="canViewPaymentRecord"
                  class="payment-record-link"
                  :to="{ name: 'MemberBuyPayOffline', query: { pay_sn: order_info.pay_sn } }"
                >View payment record</router-link>
            </div>
        </div>
        <mt-popup v-model="popupRefund" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="After sale" class="common-header">
                    <mt-button slot="left" icon="back" @click="popupRefund=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <div @click='refund(1)'><mt-cell class="menu-item" title="Refund" is-link></mt-cell></div>
                <div @click='refund(2)'><mt-cell class="menu-item" title="Return" is-link></mt-cell></div>
            </div>
        </mt-popup>
    </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui'
import { getOrderInfo } from '../../../api/memberOrder'
export default {
  name: 'MemberOrderDetail',
  data () {
    return {
      order_info: null,
      rec_id: 0,
      popupRefund: false
    }
  },

  created: function () {
    if (this.$route.query.order_id) {
      getOrderInfo(this.$route.query.order_id).then(res => {
        this.order_info = res.result.order_info
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },

  computed: {
    hasVoucher () {
      return this.order_info && this.order_info.extend_order_common && this.order_info.extend_order_common.voucher_code
    },
    canViewPaymentRecord () {
      return this.order_info && this.order_info.payment_code === 'offline' && !!this.order_info.pay_sn
    }
  },

  methods: {
    goRefund (refund) {
      if (refund.return_type == 1) {
        this.$router.push({ name: 'MemberRefundView', query: { refund_id: refund.refund_id } })
      } else {
        this.$router.push({ name: 'MemberReturnView', query: { refund_id: refund.refund_id } })
      }
    },
    showRefund (rec_id) {
      this.rec_id = rec_id
      this.popupRefund = true
    },
    refund (type) {
      this.$router.push({ name: 'MemberReturnForm', query: { type: type, order_id: this.order_info.order_id, order_goods_id: this.rec_id } })
    },

    complaint (order_id, goods_id) {
      this.$router.push({ name: 'MemberComplaintForm', query: { order_id: order_id, goods_id: goods_id } })
    }
  }
}
</script>
<style lang="scss" scoped>
    .order-body {
        overflow: auto;
        position: absolute;
        top: 2rem;
        bottom: 2.5rem;
        left: 0;
        right: 0;
        width: 100%;
        .desc{
            .container {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                background-color: #fff;
                margin-top: 0.5rem;
            }
            .title {
                width:7rem;
                font-size:0.7rem;
                color: #333;
                margin-left:0.6rem;
                margin-top: 0;
            }
            .subtitle {
                flex: 1;
                margin-left:1rem;
                margin-right:0.6rem;
                color: $primaryColor;
                font-size:0.7rem;
                text-align: right;
            }
        }
    }
    .order_state {
        background:#e93b3d;
        height:3.5rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        i {
            color:#fff;
            font-size:1.2rem;
            padding: 0 0.5rem;
        }
        span {
            font-size:0.8rem;
            color: #fff;
        }
    }
    .containers {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        border-bottom: 1px solid #e8eaed;
    }
    .photo {
        width:4rem;
        height:4rem;
        margin:0.75rem 0.5rem 0.75rem 0.75rem;
        border: 1px solid #e8eaed;
        flex-basis:4rem;
        flex-shrink: 0;
    }
    .right-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 0 0.75rem 0 0;
        width: 100%;
        overflow: hidden;
    }
    .title {
        /*height: 2.4rem;*/
        line-height: 0.8rem;
        margin-top:0.75rem;
        color: #333;
        font-size:0.6rem;
        overflow: hidden;
        /*text-overflow: ellipsis;
        white-space: nowrap;*/
    }
    .property {
        font-size:0.65rem;
        color: #7c7f88;
        padding-top:0.5rem;
    }
    .count {
        margin-top:0.2rem;
        color: #7c7f88;
        font-size:0.65rem;
        margin-right:0.5rem;
    }
    .desc-wrapper {
        height:1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top:0.4rem;
    }
    .price {
        color: $primaryColor;
        font-size:0.8rem;
        margin-left: 0;
    }
    .count {
        color: #7c7f88;
        font-size:0.8rem;
        margin-left:0.5rem;
    }
    .address {
        height:4.4rem;
        background-color: #fff;
        margin-bottom:0.5rem;
        div {
            padding: 0.5rem 0.5rem 0;
        }
        img {
            height:0.8rem;
        }
        span {
            color: #333;
            font-size:0.8rem;
            &.mobile {
                padding-left:1rem;
            }
        }
        p {
            margin:0.25rem 0.9rem 0.5rem 0.5rem;
            font-size:0.7rem;
            color: #7c7f88;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }
    .contact {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height:2.3rem;
        background-color: #fff;
        margin-top:0.4rem;
        border-bottom: 1px solid #e8eaed;
        padding: 0 0.65rem;
        span {
            font-size:0.6rem;
            color: #333;
            padding-right:0.3rem;
        }
        img {
            width:0.6rem;
            height: 0.65rem;
        }
    }
    .detail {
        display: flex;
        flex-direction: column;
        font-size:0.7rem;
        color: #7c7f88;
        background-color: #fff;
        margin:0.4rem 0;
        box-sizing: border-box;
        .number {
            padding:0.7rem 0.8rem;
            border-bottom: 1px solid #e8eaed;
            p {
                padding-top:0.3rem;
                font-size:0.7rem;
            }
            button {
                color: #7c7f88;
                background-color: #fff;
                border: 1px solid #7c7f88;
                width:2.7rem;
                height:1rem;
                border-radius:0.1rem;
                font-size: 0.7rem;
            }
        }
        .pay {
            border-bottom: 1px solid #e8eaed;
            padding:0.7rem 0.8rem;
        }
        .givetime {
            padding:0.7rem 0.8rem;
            font-size:0.7rem;
        }
        input {
            background-color: #fff;
            border: 1px solid #7c7f88;
        }
    }
    .desc {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding-top:0.6rem;
        box-sizing: border-box;
        margin-bottom:0;
        .desc-item {
            flex: 1;
            margin-top:0.5rem;
        }
        .amount {
            display: flex;
            justify-content: flex-start;
            font-size:0.7rem;
            color: #333;
            padding-left:0.6rem;
            padding-right:0.75rem;
            border-top: 1px solid #e8eaed;
            margin-top:0.6rem;
            height:2.2rem;
            line-height:2.2rem;
            span {
                font-size:0.8rem;
                color: $primaryColor;
            }
        }
        .payment-record-link {
            display: block;
            height: 1.8rem;
            margin: 0 0.75rem 0.75rem 0.6rem;
            border: 1px solid $primaryColor;
            border-radius: 0.18rem;
            color: $primaryColor;
            font-size: 0.65rem;
            line-height: 1.8rem;
            text-align: center;
            text-decoration: none;
            background: #fff;
        }
    }
    .ship {
        margin-bottom: 0;
    }
    .order_store{background:#fff;height:1rem;line-height:1rem;padding:0.5rem 0.8rem;border-bottom:1px solid #f5f5f5}
    .order_store span{color:#333;font-size:0.7rem;font-weight:600;float:left;margin:0 0.4rem;}
    .order_store i.store{float:left}
    .order_store i.more{float:left;font-size:0.7rem;}
    .pickup-code{font-size:.65rem;color:#fff}
</style>
<!-- 字体图标样式覆盖 -->
<style>
    .mint-toast-icon {
        font-size: 1.9rem;
    }
    button {
        padding: 0;
    }
</style>
